import React, { useCallback, useEffect, useState } from 'react';
import {
  Root,
  DetailsWrapper,
  DetailsRoutesWrapper,
  HorizontalLine,
  StudentDetails,
  StudentIdHeading,
  StudentNameHeading,
  POCHeading,
  POCValue,
} from '../../student-details/styled-comps';
import { AppProvider } from '../../../app-context';
import { Drawer } from 'comps';

import { FlexView, Row, COLORS, Col } from '@cuemath/comps';

import { useHistory } from 'react-router-dom';
import { parse } from 'query-string';
import { TEACHER_TAB_MENU } from 'comps/tab-menu/tabs';
import { useTeacherGet } from 'actions/teacher-v2';
import ActiveStatusIndicator from 'comps/student-statusI-indicator';
import { Button, Separator, Text } from '@cuemath/web-comps';
import LAYOUT from 'constants/layout';
import CopyButton from 'comps/copy-button';
import {
  TeacherRetentionSummary,
  TeacherRetentionFormula,
} from '../teacher-performance/components';
import {
  TEACHER_RETENTION_RATE_TAB,
  TEACHER_DETAILS_DRAWERS_CONFIG,
  TEACHER_DETAILS_DRAWERS,
} from 'constants/teacher-details';
import styled from 'styled-components';
import { getUserFullName } from 'utils';

const POCValueWrapper = styled.div`
  max-width: 182px;
  overflow-wrap: break-word;
`;
const POCValueDrawer = styled(POCValue)`
  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const VerticalLine = styled(Separator)`
  width: 1px;
  margin: 0 12px;
`;

function TeacherDetailView({ match }) {
  const [sidePanelView, setSidePanelView] = useState({});
  const history = useHistory();
  const {
    location: { search },
  } = history;

  const {
    params: { teacherId },
  } = match || {};

  const { teacher_tab: studentTab } = parse(search);

  const tab = studentTab
    ? TEACHER_TAB_MENU?.find(({ path }) => path === studentTab)
    : TEACHER_TAB_MENU?.[0];
  const { Component, path } = tab || {};

  const { data: teacherDetails, get: getTeacher, resource } = useTeacherGet();
  const { isStale, isProcessing, isProccessed } = resource ?? {};
  const { name, state, rm_data: rmData } = teacherDetails || {};

  const { first_name: rmFirstName, last_name: rmLastName, id: rmId } = rmData ?? {};

  const fetchTeachers = useCallback(() => {
    const query = { embed: ['creds', 'psm_info'] };
    teacherId && getTeacher(teacherId, query);
  }, [teacherId, getTeacher]);

  useEffect(() => {
    if (!isProcessing && !isProccessed) {
      fetchTeachers();
    }
  }, [fetchTeachers]);

  useEffect(() => {
    if (isStale) {
      fetchTeachers();
    }
  }, [isStale]);

  const handleOpenDrawer = type => {
    setSidePanelView({
      view: type,
      title: TEACHER_DETAILS_DRAWERS_CONFIG?.[type]?.label,
      props: {},
    });
  };

  const openCSMDetails = () => {
    rmId && window.open(`/users/csm/${rmId}`, '_blank');
  };

  const isCurrentTabRetentionRate = path === TEACHER_RETENTION_RATE_TAB;

  return (
    <Root>
      <AppProvider state={{ setSidePanelView, sidePanelView }}>
        <Drawer />
        <DetailsWrapper>
          <StudentDetails>
            <Row justifyContent="space-between" alignItems="flex-start">
              <StudentNameHeading variant="h5">{name || '-'}</StudentNameHeading>
              <ActiveStatusIndicator status={state || '-'} />
            </Row>
            <Separator height={24} />
            <Row>
              <POCHeading variant="eyebrow2">CSM</POCHeading>
              <POCValueWrapper>
                <POCValueDrawer variant="cta1" onClick={openCSMDetails}>
                  {getUserFullName(rmFirstName, rmLastName) || '-'}
                </POCValueDrawer>
              </POCValueWrapper>
            </Row>
            <HorizontalLine marginTop="4px" />
            <FlexView>
              <StudentIdHeading justifyContent="space-between">
                <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
                  Teacher ID
                </Text>
              </StudentIdHeading>
              <CopyButton copyMessage="Copy Teacher ID" text={teacherId} />
            </FlexView>
            <Separator height={LAYOUT.GUTTER} />
            <Row>
              <Col gutter={0}>
                <Button
                  color={COLORS.COLA_LIGHTER}
                  variant="tertiaryWithUnderline"
                  label="Licenses"
                  size="small"
                  onClick={() => handleOpenDrawer(TEACHER_DETAILS_DRAWERS.LICENSE)}
                />
              </Col>
              <VerticalLine color={COLORS.COLA} height={LAYOUT.GUTTER} />
              <Col gutter={0}>
                <Button
                  color={COLORS.COLA_LIGHTER}
                  variant="tertiaryWithUnderline"
                  label="Trial Preferences"
                  size="small"
                  onClick={() =>
                    handleOpenDrawer(TEACHER_DETAILS_DRAWERS.TRIAL_PREFERENCE)
                  }
                />
              </Col>
            </Row>
            <Separator height={LAYOUT.GUTTER} />
            {isCurrentTabRetentionRate && (
              <>
                <TeacherRetentionSummary />
                <Separator height={LAYOUT.GUTTER / 2} />
                <TeacherRetentionFormula />
              </>
            )}
          </StudentDetails>
        </DetailsWrapper>
        <DetailsRoutesWrapper>
          <Component teacherId={teacherId} currentTab={path} />
        </DetailsRoutesWrapper>
      </AppProvider>
    </Root>
  );
}

export default TeacherDetailView;
